import React, { Component } from "react";

import PDP from "../PDP/PDP";
import PageNotFound from "../PageNotFoundContainer/PageNotFound";
import axios from "axios";
import { withRouter } from "react-router";


class ProductDetailPageContainer extends Component {
  state = { products: [] };

  componentDidMount() {
    const { match } = this.props;
    const productId = match.params.productId;

    axios
      .get("https://api.shopmuthu.com/product/" + productId)
      .then((response) => {
        console.log(response);
        console.log(response.data.length);        
        this.setState({products:response.data});
       
       
      });
  }

  toggleProduct = () => {
    const doesShow = this.state.showProduct;
    this.setState({ showProduct: !doesShow });
  };

  showProductDisplayPage = () => {};

  render() {
    let product = null;

    //console.log(this.state.products.specification);
    product = (
      <div>
        {
        
        this.state.products.map((product, index) => {
          return (
            
            <PDP
              click={() => this.showProductDisplayPage(index)}
              product={product}
              specification={product.specification}
              key={product.productName}
            />
          );
        })

        }
      
      </div>
    );

    return <React.Fragment>{product}</React.Fragment>;
  }
}

export default withRouter(ProductDetailPageContainer);
